module.exports = ".jumbotron {\n  background-color: white; }\n"